import './styles.sass';

import React from 'react';
import Transition from 'components/Explorer/Transition';
import { Link } from 'react-router-dom';

import Gauge from 'components/Explorer/Gauge';
import TopItemList from 'components/Highlights/TopItemList';
import NumberHelper from 'util/number_helper';
import * as QueryParams from 'components/Explorer/models/query_params';
import useExplorerData, { Loading } from 'hooks/useExplorerData';
import useQueryParams from 'hooks/useQueryParams';

const COLORS = ['#03A9F4', '#E91E63', '#FFA000', '#4CAF50', '#673AB7'];

const linkForJournal = (params, journal) => {
  const filters = { ...(params.filters || {}), 'journal_id[]': [journal.id] };
  return QueryParams.locationFor(QueryParams.withFilters(params, filters), '/mentions');
};

const trackJumpLink = () => {
  Analytics.trackEvent('highlights-click-jump-link', { jumpedTo: 'top-journals' });
};

const TopJournals = () => {
  const params = useQueryParams();
  const { data, loading } = useExplorerData('highlights/top_journals', params, { reloadOn: ['filters'] });

  const isLoading = loading === Loading.NOT_STARTED || loading === Loading.IN_PROGRESS;
  const hasResults = Array.isArray(data) && data.length > 0;

  const journalRank = (rank, index) => (
    <TopItemList.Item key={rank.journal.id}>
      <Gauge percentage={rank.percent} color={COLORS[index % COLORS.length]} />
      <div className="description">
        <div className="title">
          <Link to={linkForJournal(params, rank.journal)}>{rank.journal.title}</Link>
        </div>
        <div className="meta">
          {I18n.htmlSafe('Explorer.Highlights.TopJournals.meta.mentions', {
            count: rank.count,
            formattedCount: NumberHelper.formatStatistic(rank.count)
          })}
          <span>&nbsp;</span>
          {I18n.htmlSafe('Explorer.Highlights.TopJournals.meta.outputs', {
            count: rank.output_count,
            formattedCount: NumberHelper.formatStatistic(rank.output_count)
          })}
        </div>
      </div>
    </TopItemList.Item>
  );

  const content = () => {
    if (loading === Loading.ERROR) {
      return <div className="Highlights-error-message">{I18n.t('Explorer.loading_error')}</div>;
    }
    return (
      <div key="content" className="Highlights-content Highlights-TopJournals-content">
        {hasResults ? (
          <TopItemList>{data.map(journalRank)}</TopItemList>
        ) : (
          <div className="Highlights-content-empty-message">{I18n.t('Explorer.Highlights.TopJournals.empty')}</div>
        )}
      </div>
    );
  };

  return (
    <div className="Highlights-TopJournals Highlights-block">
      <h2 className="Highlights-title">{I18n.t('Explorer.Highlights.TopJournals.title')}</h2>
      <div className="Highlights-content-wrapper">
        <Transition>
          {isLoading ? <div key="loadingMessage" className="Highlights-loading-message" /> : content()}
        </Transition>
        {hasResults && (
          <Link
            onClick={trackJumpLink}
            to={QueryParams.locationFor(params, '/journals')}
            className="Highlights-jump-link"
          >
            {I18n.t('Explorer.Highlights.TopJournals.more')}
          </Link>
        )}
      </div>
    </div>
  );
};

export default TopJournals;
